import { applicationSettings } from '../../settings/application';
import { config as JonaxelCrConfig } from '../jonaxel/ClothesRailConfig';
import getAurdalClothesRailConfig from '../aurdal/getClothesRailConfig';
import IvarTableConfig from '../ivar/TableConfig';
import { ITEMS } from '../../constants';

/**
 * Gets a config object for specific items (e.g. extendables)
 *
 * @param {Object} item The item in need of a config
 * @returns {Object} The found config for the item, or undefined if no config
 */
export default function getItemConfig(item) {
  switch (item.filter.type) {
    case ITEMS.CLOTHES_RAIL: {
      switch (applicationSettings.applicationName) {
        case 'JONAXEL':
          return JonaxelCrConfig;
        case 'AURDAL':
          return getAurdalClothesRailConfig(item);
        default:
          break;
      }
      break;
    }
    case ITEMS.TABLE: {
      switch (applicationSettings.applicationName) {
        case 'IVAR':
          return IvarTableConfig;
        default:
          break;
      }
      break;
    }
    default:
      break;
  }
}
